import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { CAMPAIGNS_TABLE_METRICS } from '../CampaignsHealthMetrics.constants';

export const MetricsTableContainer = styled.div`
  min-height: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const Table = styled.div`
  display: grid;
  grid-template-columns: minmax(${pxToRem(90)}, 1fr) repeat(${CAMPAIGNS_TABLE_METRICS.length}, minmax(0, 1fr)) minmax(${pxToRem(105)}, 1fr);
  column-gap: ${spacing.half};
  row-gap: ${spacing.base};
  color: ${colors.textSecondary};
  padding: ${spacing.threeQuarter} 0;
`;
